import React from 'react';
import clsx from 'clsx';
import { Label, Table } from 'semantic-ui-react';
import { filterWithMinimumLength, removeDuplicates } from '@/utils/resultsHelper';
import LinksLabels from '../LinksLabels';

const LinksCell = ({ links, title, className }) => {
  const items = removeDuplicates(filterWithMinimumLength(links || []), true);
  return (
    <Table.Cell className={clsx('aridhia-links-cell', className)} title={title}>
      {items.length > 0 && (
        <Label.Group className="aridhia-tag">
          <LinksLabels items={items} />
        </Label.Group>
      )}
    </Table.Cell>
  );
};

export default LinksCell;
